module.exports = __webpack_public_path__ + "static/media/-_Learning Management.968df885.png";